import { useRef } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { FloatingLabel, Form, Button as BSButton, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ErrorPage } from "../error";
import { TenantModel } from "../../data/entities";
import { PermissionDefinitions } from "../../security";
import { usePageActions } from "../";
import { TenantService } from "../../services";
import { getUserTenantId } from "../../app";
import { useAsync,
  useCRUDHandlers,
  usePermission,
  useUrlParams } from "../../hooks";
import {
  Button,
  IconAndText,
  IconDefinitions,
  Card,
  SpinnerDefault,
} from "../../components";

export function HostTenantDetailsPage() {
  const tenantService = new TenantService();
  const id = parseInt(useUrlParams("id"));
  const submitRef = useRef<HTMLButtonElement>(null);
  const { value: tenant, loading, error } = useAsync(() => tenantService.get(id), [id]);
  const { editItem } = useCRUDHandlers(tenantService, "Tenant");

  const tenantId = useSelector(getUserTenantId());
  const canEditTenant = usePermission(PermissionDefinitions.host.edit(tenantId!));

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required")
  });

  usePageActions(
    canEditTenant && (
      <Button onClick={() => submitRef.current?.click()}>
        <IconAndText iconName={IconDefinitions.save} text="Save" />
      </Button>
    ),
    [canEditTenant]
  );

  if (error) return <ErrorPage message={error.message} />
  if (!tenant || loading) return <SpinnerDefault />

  return (
    <Card title="Details">
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          ...tenant,
          name: tenant.name,
        }}
        onSubmit={(values) => {
          editItem(values as TenantModel);
        }}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <Form onSubmit={handleSubmit} noValidate>
            <Row>
              <Col>
                <FloatingLabel label="Name">
                  <Form.Control
                      type="string"
                      placeholder="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      disabled={!canEditTenant}
                      isInvalid={touched.name && !!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                </FloatingLabel>
              </Col>
            </Row>
            <BSButton ref={submitRef} type="submit" className="d-none" />
          </Form>
        )}
      </Formik>
    </Card>
  );
}

export default HostTenantDetailsPage;

